/*==================================================
=          PERTUMBUHAN WHO USIA 0–5 TAHUN
==================================================*/

/*==================================================
=          TINGGI BADAN MENURUT USIA
==================================================*/

function calculateHeightForAge(
    height,
    ageMonths,
    sex,
    data
) {

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const ref =
        data?.[gender]?.[ageMonths];

    if (!ref) {

        return {
            error:
                "Data referensi tinggi badan menurut usia WHO tidak ditemukan."
        };

    }

    return createGrowthResult(
        height,
        ref
    );

}

/*==================================================
=          BERAT BADAN MENURUT USIA
==================================================*/

function calculateWeightForAge(
    weight,
    ageMonths,
    sex,
    data
) {

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const ref =
        data?.[gender]?.[ageMonths];

    if (!ref) {

        return {
            error:
                "Data referensi berat badan menurut usia WHO tidak ditemukan."
        };

    }

    return createGrowthResult(
        weight,
        ref
    );

}

/*==================================================
=                 LINGKAR KEPALA
==================================================*/

function calculateHeadCircumference(
    head,
    ageMonths,
    sex,
    data
) {

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const ref =
        data?.[gender]?.[ageMonths];

    if (!ref) {

        return {
            error:
                "Data referensi lingkar kepala WHO tidak ditemukan."
        };

    }

    return createGrowthResult(
        head,
        ref
    );

}

/*==================================================
=          PENILAIAN PERTUMBUHAN LENGKAP
==================================================*/

function calculateGrowth05(
    inputs,
    datasets
) {

    const ageMonths = inputs.ageMonths;

    const results = {};

    if (datasets.height) {

        results.height =
            calculateHeightForAge(
                inputs.height,
                ageMonths,
                inputs.sex,
                datasets.height
            );

    }

    if (datasets.weight) {

        results.weight =
            calculateWeightForAge(
                inputs.weight,
                ageMonths,
                inputs.sex,
                datasets.weight
            );

    }

    if (
        inputs.head > 0 &&
        datasets.head
    ) {

        results.head =
            calculateHeadCircumference(
                inputs.head,
                ageMonths,
                inputs.sex,
                datasets.head
            );

    }

    if (
        ageMonths < 24 &&
        datasets.weightLength
    ) {

        results.weightLength =
            calculateWeightForLength(
                inputs.weight,
                inputs.height,
                inputs.sex,
                datasets.weightLength
            );

    } else if (datasets.weightHeight) {

        results.weightHeight =
            calculateWeightForHeight(
                inputs.weight,
                inputs.height,
                inputs.sex,
                datasets.weightHeight
            );

    }

    return results;

}

/*==================================================
=          BERAT MENURUT PANJANG BADAN
=                 USIA 0–2 TAHUN
==================================================*/

function calculateWeightForLength(
    weight,
    length,
    sex,
    data
) {

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const key =
        (
            Math.round(length * 2) / 2
        ).toFixed(1);

    const ref =
        data?.[gender]?.[key];

    if (!ref) {

        return {
            error:
                "Data referensi berat badan menurut panjang badan WHO tidak ditemukan."
        };

    }

    return createGrowthResult(
        weight,
        ref
    );

}

/*==================================================
=          BERAT MENURUT TINGGI BADAN
=                 USIA 2–5 TAHUN
==================================================*/

function calculateWeightForHeight(
    weight,
    height,
    sex,
    data
) {

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const key =
        (
            Math.round(height * 2) / 2
        ).toFixed(1);

    const ref =
        data?.[gender]?.[key];

    if (!ref) {

        return {
            error:
                "Data referensi berat badan menurut tinggi badan WHO tidak ditemukan."
        };

    }

    return createGrowthResult(
        weight,
        ref
    );

}

/*==================================================
=          MEMBUAT HASIL PERTUMBUHAN
==================================================*/

function createGrowthResult(
    value,
    reference
) {

    const z =
        calculateZScore(
            value,
            reference
        );

    const percentile =
        zToPercentile(z);

    const growth =
        classifyGrowth(z);

    return {
        value: value,
        z: z,
        percentile: percentile,
        category: growth.category,
        advice: growth.advice
    };

}

/*==================================================
=          KLASIFIKASI PERTUMBUHAN
==================================================*/

function classifyGrowth(z) {

    if (z < -3) {

        return {
            category:
                "Sangat Rendah",

            advice:
                "Hasil berada jauh di bawah rentang pertumbuhan WHO. Konsultasikan dengan dokter atau tenaga kesehatan."
        };

    }

    if (z < -2) {

        return {
            category:
                "Rendah",

            advice:
                "Hasil berada di bawah rentang pertumbuhan WHO."
        };

    }

    if (z <= 2) {

        return {
            category:
                "Normal",

            advice:
                "Hasil berada dalam rentang pertumbuhan WHO."
        };

    }

    if (z <= 3) {

        return {
            category:
                "Tinggi",

            advice:
                "Hasil berada di atas rentang pertumbuhan WHO."
        };

    }

    return {
        category:
            "Sangat Tinggi",

        advice:
            "Hasil berada jauh di atas rentang pertumbuhan WHO. Konsultasikan dengan dokter atau tenaga kesehatan."
    };

}

/*==================================================
=          PEMERIKSAAN KESALAHAN
==================================================*/

function hasGrowthErrors(results) {

    for (const result of Object.values(results)) {

        if (result?.error) {
            return result;
        }

    }

    return null;

}